module.exports = __webpack_public_path__ + "assets/arrow-up.732adacc.svg";